import React from 'react';

import {
    EventTriggerAttachmentView,
} from 'src/modules/event-review/header-block/event-trigger-attachment/event-trigger-attachment.view';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
};

export const EventTriggerAttachmentController = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
    } = props;

    return (
        <EventTriggerAttachmentView
            triggerAttachments={changeRequest.triggerAttachments}
            eventCodeInfo={eventCodeInfo}
        />
    );
};
